import React from 'react';

export default class CodeGenarator extends React.Component{
    constructor(props){
        super(props);
    }
    // appenderCodes(id, st) {
    //     //console.log(st)
    //     let code = codeToCode(st)
    //     //console.log(code)
    //     $('#' + id).append(code).wrap("<pre></pre>");
    //     $('#' + id).data("code", (allcodes.length - 1))

    //   }
      codeToCode(codes) {
        let co = true;
        let qoutTextColor='3d84a8'
        let qoutflag=false;
        let colors=['d04925','f7be16','00a79d','444444','a0855b','204969','1c2938','f5b5fc']
        let lt=[]
        let pa=[]
        let colorCunter=0
        let value = ''
        let textKeeper = ''
        for (let index = 0; index < codes.length; index++) {
          const element = codes.charAt(index);
          if (element === '<') {
            if (co) {
              value += "<span class='p'>&lt;</span>"
            } else {
              value += "<span class='p'>" + textKeeper + "</span>"
              textKeeper = ""
              value += "<span class='p'>&lt;</span>"
              co = true;
            }
          }else if (element === '(') {
            let color=colors[colorCunter];
            pa.push(color)
            colorCunter++;
            if(colorCunter>=colors.length){
              colorCunter=0
            }
            if (co) {
              value += "<span style='color:#"+color+"'>(</span>"
            } else {
              value += "<span class='p'>" + textKeeper + "</span>"
              textKeeper = ""
              value += "<span class='p' style='color:#"+color+"'>(</span>"
              co = true;
            }
          }else if (element === '"') {
            
            if (co) {
              value += "<span class='p' style='color:#"+qoutTextColor+"'>&quot;</span>"
            } else {
              let col=""
              // if(qoutflag){
              //   qoutflag=false;
              //   col="style='color:#"+qoutTextColor+"'"
              // }
              value += "<span class='p' "+col+">" + textKeeper + "</span>"
              textKeeper = ""
              value += "<span class='p' style='color:#"+qoutTextColor+"'>&quot;</span>"
              co = true;
            }
            // if(!qoutflag){
            //   qoutflag=true
            // }
          }else if (element === ')') {
            let color=(pa.length>0)?pa.pop():'#000'
            if (co) {
              value += "<span class='p' style='color:#"+color+"'>)</span>"
            } else {
              value += "<span class='p'>" + textKeeper + "</span>"
              textKeeper = ""
              value += "<span class='p' style='color:#"+color+"'>)</span>"
              co = true;
            }
          }
          else if (element == '>') {
            if (co) {
              value += "<span class='p'>&gt;</span>"
            } else {
              value += "<span class='p'>" + textKeeper + "</span>"
              textKeeper = ""
              value += "<span class='p'>&gt;</span>"
              co = true;
            }
          }  else {
            co = false;
            textKeeper += element
          }

          // //console.log(element)
        }
        if (textKeeper.length > 0) {
          value += textKeeper
        }
        return value;
      }

    render(){
        let codes=this.codeToCode(this.props.code)

        var Response = <div dangerouslySetInnerHTML={{__html: codes}}></div>
        return(
            <code>
                {/* {Response} */}
                <pre>
                    {Response}
                </pre>
            </code>
        )
    }
    

}